import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from 'ui/drawer'

import { BeforeInstallPromptButton } from '~/boundedContext/settings/components/before-install-prompt-button'
import { IOSInstallButton } from '~/boundedContext/settings/components/ios-install-button'
import { useCanDisplayInstallOnAndroid } from '~/boundedContext/settings/hooks/use-can-display-install-on-android'
import { useSettingsStore } from '~/stores/settings'
import { canDisplayInstallOnIos } from '~/utils/can-display-install-on-ios'

export const InstallPrompt = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()
  const appWasInstalled = useSettingsStore(state => state.appWasInstalled)
  const isInstallPromptDisplayed = useSettingsStore(state => state.isInstallPromptDisplayed)
  const isInstallSupported = useCanDisplayInstallOnAndroid() || canDisplayInstallOnIos()
  const patchSettings = useSettingsStore(state => state.patchSettings)

  const skipRender = appWasInstalled || !isInstallSupported || !!isInstallPromptDisplayed

  useEffect(() => {
    if (skipRender) return

    const timer = setTimeout(() => setIsOpen(true), 2 * 60 * 1000) // after 2 minutes

    return () => clearTimeout(timer)
  }, [skipRender])

  if (skipRender) return null

  const saveInstallDisplayed = () => {
    patchSettings({ isInstallPromptDisplayed: true })
  }

  const onInstallClick = () => {
    saveInstallDisplayed()
    setIsOpen(false)
  }

  return (
    <Drawer
      onOpenChange={nextOpen => {
        if (nextOpen) return
        saveInstallDisplayed()
        setIsOpen(false)
      }}
      open={isOpen}
    >
      <DrawerContent>
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>{t('Install')}</DrawerTitle>
            <DrawerDescription>{t('You can add the app to your home screen')}</DrawerDescription>
          </DrawerHeader>

          <DrawerFooter className="p-4">
            <IOSInstallButton onClick={onInstallClick} />
            <BeforeInstallPromptButton onClick={onInstallClick} />
            <DrawerClose onClick={() => setIsOpen(false)} render={<Button variant="outline" />}>
              {t('Cancel')}
            </DrawerClose>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
